import { render } from "./MaterialSupportAdressTable.vue?vue&type=template&id=6b920f9c&scoped=true"
import script from "./MaterialSupportAdressTable.vue?vue&type=script&lang=js"
export * from "./MaterialSupportAdressTable.vue?vue&type=script&lang=js"

import "./MaterialSupportAdressTable.vue?vue&type=style&index=0&id=6b920f9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b920f9c"]])

export default __exports__